<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="60%" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        " :bodyStyle="{ maxHeight: '75vh', overflow: 'auto' }">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules" style="margin-top: 30px;">
                <a-form-item label="服务商名称" name="name" required>
                    <a-input placeholder="请输入" v-model:value="formState.name"></a-input>
                </a-form-item>
                <a-form-item label="服务商简称" name="platform_abbreviation" required>
                    <a-input placeholder="请输入" v-model:value="formState.platform_abbreviation"></a-input>
                </a-form-item>
                <a-form-item label="统一社会信用代码" name="social_credit_code">
                    <a-input placeholder="请输入统一社会信用代码" v-model:value="formState.social_credit_code"></a-input>
                </a-form-item>
                <a-form-item label="公司地址省市区" name="company_area_ids">
                    <AddressCascader v-model:value="formState.company_area_ids" @change="
                        (res, e) => {
                            companyPauaChange(res, e, 'company_detailed_address')
                        }
                    "></AddressCascader>
                </a-form-item>
                <a-form-item label="详细地址" name="company_detailed_address">
                    <a-input placeholder="请输入公司注册地址" v-model:value="formState.company_detailed_address"> </a-input>
                </a-form-item>
                <a-form-item label="客服电话" name="kefu_phone" required>
                    <a-input placeholder="请输入" v-model:value="formState.kefu_phone" @change="
                        (v) => {
                            phoneChange(v, 'kefu_phone')
                        }
                    "></a-input>
                </a-form-item>
                <a-form-item label="平台余额充值支付方式">
                    <a-checkbox-group v-model:value="formState.allowed_ptyecz_method">
                        <a-checkbox :value="8">微信支付</a-checkbox>
                        <a-checkbox :value="1">对公转账</a-checkbox>
                        <a-checkbox :value="2">线下转款</a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item label="平台公章" name="official_seal">
                    <Upload :upload_path="`public/uploads/服务商/${formState.name}/平台资料/`" uploadType="picture-card"
                        :limitation="1" :accept="['png', 'jpg', 'jpeg', 'pdf']" v-model:value="formState.official_seal"
                        uploadText="上传平台公章"> </Upload>
                </a-form-item>
                <div class="form-tips-title">微信商户配置</div>
                <a-form-item label="子商户APPID" name="sub_appid">
                    <a-input placeholder="子商户APPID" v-model:value="formState.sub_appid"></a-input>
                </a-form-item>
                <a-form-item label="子商户号" name="sub_mchid">
                    <a-input placeholder="子商户号" v-model:value="formState.sub_mchid"></a-input>
                </a-form-item>
                <a-form-item label="提供的微信支付费率" name="sub_wechatpay_rates">
                    <a-input placeholder="提供的微信支付费率" v-model:value="formState.sub_wechatpay_rates"></a-input>
                </a-form-item>
                <div class="form-tips-title">对公转账配置</div>
                <a-form-item label="对公账号信息" name="bank_info">
                    <a-textarea v-model:value="formState.bank_info" placeholder="请输入对公账号信息" :rows="3"></a-textarea>
                </a-form-item>
                <!-- 邮寄方式start -->
                <div class="form-tips-title">快递信息</div>
                <ShippRule v-model:value="formState.shipp_rule" :fwsPtid="props.detailData?.id"></ShippRule>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { AddressCascader, AssociateAuthorization } from '@/components'
import ShippRule from '@/components/shippingRule/ShippRule.vue'
import { IShippingRule } from '@/components/shippingRule/shippingRule'
import Upload from '@/components/base/Upload.vue'
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {
    company_area_ids: [{ required: true, message: '请选择公司地址省市区' }],
}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    modalTitle: string
    loading: boolean
    isEdit: boolean
}
const state = reactive<state>({
    modalTitle: '新增服务商',
    loading: false,
    isEdit: false,
})
const checkdatastate = reactive<any>({})
interface formState {
    name: string
    platform_abbreviation: string
    social_credit_code: string
    company_area_ids: string
    company_detailed_address: string
    kefu_phone: string
    allowed_ptyecz_method: number[]
    sub_appid: string
    sub_mchid: string
    sub_wechatpay_rates: number
    bank_info: string
    shipp_rule: IShippingRule
    official_seal: string | undefined
}
let formState = reactive<formState>({
    name: '',
    platform_abbreviation: '',
    social_credit_code: '',
    company_area_ids: '',
    company_detailed_address: '',
    allowed_ptyecz_method: [],
    kefu_phone: '',
    sub_appid: '',
    sub_mchid: '',
    sub_wechatpay_rates: 0.006,
    bank_info: '',
    shipp_rule: {
        1: {
            status: 2,
            logistics_rule_id: null,
            free_money: 0,
        },
        2: {
            status: 2,
            logistics_rule_id: null,
            free_money: 0,
        }
    },
    official_seal: '',
})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑【' + props.detailData.name + '】服务商'
        state.isEdit = true
        queryDetail(props.detailData?.id)
    }
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/fws_platform/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formState, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}
// 省市区 选择和替换
const companyPauaChange = (res, e, type) => {
    let address = `${e[0].name}${e[1].name}${e[2].name}`
    formState[type] = address
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
    //判断str是不是手机号码
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formState[type] = str
    }
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/fws_platform/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/fws_platform',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
</script>

<style lang="less" scoped></style>
